import {Alert, Select, Typography} from 'antd';
import type {AzdoRepository} from '../../api/azdo-lookup';

interface Props {
    projectSelected: boolean;
    repositories: AzdoRepository[];
    loading: boolean;
    error: string | null;
    selectedRepositoryId: string | null;
    onSelect: (id: string) => void;
    disabled?: boolean;
}

export const RepositoryStep = ({
    projectSelected,
    repositories,
    loading,
    error,
    selectedRepositoryId,
    onSelect,
    disabled,
}: Props) => (
    <section>
        <Typography.Title level={5}>2. Repository</Typography.Title>
        {!projectSelected ? (
            <Select
                showSearch={false}
                style={{width: '100%'}}
                placeholder='Select a project first'
                disabled
                options={[]}
            />
        ) : error ? (
            <Alert type='error' title='Failed to load repositories' description={error}/>
        ) : (
            <Select
                showSearch={true}
                optionFilterProp='label'
                style={{width: '100%'}}
                placeholder='Select a repository'
                loading={loading}
                value={selectedRepositoryId ?? undefined}
                onChange={onSelect}
                disabled={disabled || loading}
                options={repositories.map((r) => ({value: r.id, label: r.name}))}
            />
        )}
    </section>
);
